export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działania"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj informacje o kolekcjonerze"])}
}